import * as FEATURES from './features';
export const FEATURE_DESCRIPTION_MAP = {
  [FEATURES.ONE_TO_ONE_EMAIL]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.oneToOneEmail.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.oneToOneEmail.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneEmail.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneEmail.description'
  },
  [FEATURES.CHANNEL_SWITCHING]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.channelSwitching.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.channelSwitching.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.channelSwitching.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.channelSwitching.description'
  },
  [FEATURES.GMAIL_OUTLOOK_AND_MICROSOFT_EXCHANGE_INTEGRATIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.gmailOutlookAndMicrosoftExchangeIntegrations.description'
  },
  [FEATURES.EMAIL_TRACKING_AND_NOTIFICATIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailTrackingAndNotifications.description'
  },
  [FEATURES.ONE_TO_ONE_VIDEO_MESSAGING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneVideoMessaging.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneVideoMessaging.description'
  },
  [FEATURES.MULTIPLE_EMAIL_SIGNATURES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.multipleEmailSignatures.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.multipleEmailSignatures.description'
  },
  [FEATURES.EMAIL_TEMPLATES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.emailTemplates.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailTemplates.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailTemplates.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailTemplates.description'
  },
  [FEATURES.SALES_CONTENT_ANALYTICS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.salesContentAnalytics.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesContentAnalytics.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesContentAnalytics.description'
  },
  [FEATURES.LIVE_CHAT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.liveChat.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.liveChat.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.liveChat.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.liveChat.description'
  },
  [FEATURES.LOGGED_IN_VISITOR_IDENTIFICATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.loggedInVisitorIdentification.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.loggedInVisitorIdentification.description'
  },
  [FEATURES.DRAGGABLE_CHAT_WIDGET]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.draggableChatWidget.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.draggableChatWidget.description'
  },
  [FEATURES.CONVERSATIONAL_BOTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.conversationalBots.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.conversationalBots.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationalBots.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationalBots.description'
  },
  [FEATURES.TICKET_CREATION_LEAD_QUALIFICATION_AND_MEETING_BOOKING_BOTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.ticketCreationLeadQualificationAndMeetingBookingBots.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.ticketCreationLeadQualificationAndMeetingBookingBots.description'
  },
  [FEATURES.CUSTOM_BOTS_CUSTOM_BRANCHING_LOGIC_AND_ADVANCED_TARGETING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customBotsCustomBranchingLogicAndAdvancedTargeting.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customBotsCustomBranchingLogicAndAdvancedTargeting.description'
  },
  [FEATURES.FACEBOOK_MESSENGER_INTEGRATION]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.facebookMessengerIntegration.description'
  },
  [FEATURES.ADVANCED_MESSENGER_BOT_BRANCHING_AND_ADVANCED_REPORTING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.advancedMessengerBotBranchingAndAdvancedReporting.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.advancedMessengerBotBranchingAndAdvancedReporting.description'
  },
  [FEATURES.CODE_SNIPPETS_FOR_CUSTOM_MESSENGER_BOT_ACTIONS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.codeSnippetsForCustomMessengerBotActions.description'
  },
  [FEATURES.MEETING_SCHEDULER]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.meetingScheduler.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.meetingScheduler.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.meetingScheduler.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.meetingScheduler.description'
  },
  [FEATURES.AI_MEETING_ASSISTANT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.aiMeetingAssistant.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.aiMeetingAssistant.description'
  },
  [FEATURES.BOOK_ON_BEHALF_OF_OTHERS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.bookOnBehalfOfOthers.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.bookOnBehalfOfOthers.description'
  },
  [FEATURES.LEAD_FORM_ROUTING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.leadFormRouting.description'
  },
  [FEATURES.SHARED_INBOX]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.sharedInbox.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.sharedInbox.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.sharedInbox.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sharedInbox.description'
  },
  [FEATURES.CONVERSATION_ROUTING]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.conversationRouting.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationRouting.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationRouting.description'
  },
  [FEATURES.CUSTOM_VIEWS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customViews.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customViews.description'
  },
  [FEATURES.SNIPPETS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.snippets.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.snippets.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.snippets.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.snippets.description'
  },
  [FEATURES.TASKS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.tasks.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.tasks.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.tasks.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.tasks.description'
  },
  [FEATURES.TASK_CALENDAR_SYNC]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.taskCalendarSync.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.taskCalendarSync.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.taskCalendarSync.description'
  },
  [FEATURES.REPEATING_TASKS_AND_QUEUES]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.repeatingTasksAndQueues.description'
  },
  [FEATURES.CALLING]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.calling.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.calling.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.calling.description'
  },
  [FEATURES.HUBSPOT_PROVIDED_PHONE_NUMBERS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.hubspotProvidedPhoneNumbers.description'
  },
  [FEATURES.INTERACTIVE_VOICE_RESPONSE]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.interactiveVoiceResponse.description'
  },
  [FEATURES.BREEZE_PROSPECTING_AGENT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.breezeProspectingAgent.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.breezeProspectingAgent.description'
  },
  [FEATURES.LINKEDIN_SALES_NAVIGATOR_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.linkedinSalesNavigatorIntegration.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.linkedinSalesNavigatorIntegration.description'
  },
  [FEATURES.SALES_WORKSPACE]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesWorkspace.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesWorkspace.description'
  },
  [FEATURES.LEADS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.leads.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.leads.description'
  },
  [FEATURES.GUIDED_ACTIONS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.guidedActions.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.guidedActions.description'
  },
  [FEATURES.SEQUENCES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.sequences.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sequences.description'
  },
  [FEATURES.DYNAMIC_SEQUENCES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dynamicSequences.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dynamicSequences.description'
  },
  [FEATURES.TARGET_ACCOUNTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.targetAccounts.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.targetAccounts.description'
  },
  [FEATURES.ABM_TOOLS_AND_AUTOMATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.abmToolsAndAutomation.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.abmToolsAndAutomation.description'
  },
  [FEATURES.TARGET_ACCOUNTS_OVERVIEW]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.targetAccountsOverview.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.targetAccountsOverview.description'
  },
  [FEATURES.BREEZE_COPILOT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.breezeCopilot.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.breezeCopilot.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.breezeCopilot.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.breezeCopilot.description'
  },
  [FEATURES.DEALS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.deals.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.deals.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.deals.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.deals.description'
  },
  [FEATURES.DEAL_PIPELINE_AUTOMATION]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealPipelineAutomation.description'
  },
  [FEATURES.DEAL_TAGS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dealTags.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealTags.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealTags.description'
  },
  [FEATURES.CUSTOM_DEAL_TAG_RULES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customDealTagRules.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customDealTagRules.description'
  },
  [FEATURES.DEAL_SUMMARIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dealSummaries.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealSummaries.description'
  },
  [FEATURES.DEAL_SPLITS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealSplits.description'
  },
  [FEATURES.DEAL_APPROVALS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealApprovals.description'
  },
  [FEATURES.DOCUMENTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.documents.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.documents.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.documents.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.documents.description'
  },
  [FEATURES.HUBSPOT_MOBILE_APP]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.hubspotMobileApp.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.hubspotMobileApp.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.hubspotMobileApp.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.hubspotMobileApp.description'
  },
  [FEATURES.MOBILE_INBOX]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.mobileInbox.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.mobileInbox.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.mobileInbox.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.mobileInbox.description'
  },
  [FEATURES.PAYMENTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.payments.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.payments.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.payments.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.payments.description'
  },
  [FEATURES.STRIPE_PAYMENT_PROCESSING]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.stripePaymentProcessing.description'
  },
  [FEATURES.PAYMENT_LINKS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.paymentLinks.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.paymentLinks.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.paymentLinks.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.paymentLinks.description'
  },
  [FEATURES.SUBSCRIPTIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.subscriptions.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.subscriptions.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.subscriptions.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.subscriptions.description'
  },
  [FEATURES.B2B_CHECKOUT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.b2bCheckout.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.b2bCheckout.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.b2bCheckout.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.b2bCheckout.description'
  },
  [FEATURES.QUOTES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.quotes.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.quotes.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.quotes.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.quotes.description'
  },
  [FEATURES.E_SIGNATURE]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.eSignature.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.eSignature.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.eSignature.description'
  },
  [FEATURES.INVOICES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.invoices.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.invoices.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.invoices.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.invoices.description'
  },
  [FEATURES.REPORTING_DASHBOARDS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.reportingDashboards.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.reportingDashboards.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.reportingDashboards.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.reportingDashboards.description'
  },
  [FEATURES.SALES_ANALYTICS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesAnalytics.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesAnalytics.description'
  },
  [FEATURES.CUSTOM_REPORT_BUILDER]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customReportBuilder.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customReportBuilder.description'
  },
  [FEATURES.DEAL_JOURNEY_ANALYTICS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dealJourneyAnalytics.description'
  },
  [FEATURES.PRODUCTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.products.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.products.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.products.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.products.description'
  },
  [FEATURES.GOALS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.goals.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.goals.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.goals.description'
  },
  [FEATURES.CUSTOM_GOALS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customGoals.description'
  },
  [FEATURES.CONVERSATION_INTELLIGENCE]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.conversationIntelligence.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.conversationIntelligence.description'
  },
  [FEATURES.COACHING_PLAYLISTS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.coachingPlaylists.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.coachingPlaylists.description'
  },
  [FEATURES.TRACKED_TERMS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.trackedTerms.description'
  },
  [FEATURES.FORECASTING]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.forecasting.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.forecasting.description'
  },
  [FEATURES.FORECAST_ACROSS_TEAM_HIERARCHIES]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.forecastAcrossTeamHierarchies.description'
  },
  [FEATURES.AI_FORECASTING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.aiForecasting.description'
  },
  [FEATURES.PLAYBOOKS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.playbooks.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.playbooks.description'
  },
  [FEATURES.EMBED_AND_UPDATE_PROPERTIES]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.embedAndUpdateProperties.description'
  },
  [FEATURES.CUSTOM_PROPERTIES]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.customProperties.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.customProperties.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customProperties.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customProperties.description'
  },
  [FEATURES.CALCULATED_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.calculatedProperties.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.calculatedProperties.description'
  },
  [FEATURES.SYNC_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.syncProperties.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.syncProperties.description'
  },
  [FEATURES.SCORE_PROPERTIES]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.scoreProperties.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.scoreProperties.description'
  },
  [FEATURES.PREDICTIVE_LEAD_SCORING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.predictiveLeadScoring.description'
  },
  [FEATURES.FIELD_LEVEL_PERMISSIONS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.fieldLevelPermissions.description'
  },
  [FEATURES.DATA_MODEL]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.dataModel.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.dataModel.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.dataModel.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.dataModel.description'
  },
  [FEATURES.ASSOCIATION_LABELS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.associationLabels.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.associationLabels.description'
  },
  [FEATURES.CUSTOM_USER_PERMISSIONS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.customUserPermissions.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.customUserPermissions.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.customUserPermissions.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customUserPermissions.description'
  },
  [FEATURES.PERMISSION_SETS]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.permissionSets.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.permissionSets.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.permissionSets.description'
  },
  [FEATURES.CUSTOM_PERMISSION_SETS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customPermissionSets.description'
  },
  [FEATURES.SLACK_INTEGRATION]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.slackIntegration.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.slackIntegration.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.slackIntegration.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.slackIntegration.description'
  },
  [FEATURES.USER_MANAGEMENT]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.userManagement.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.userManagement.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.userManagement.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.userManagement.description'
  },
  [FEATURES.TEAMS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.teams.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.teams.description'
  },
  [FEATURES.PRESETS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.presets.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.presets.description'
  },
  [FEATURES.ORGANIZE_TEAMS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.organizeTeams.description'
  },
  [FEATURES.LOG_IN_AS_ANOTHER_USER]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.logInAsAnotherUser.description'
  },
  [FEATURES.SINGLE_SIGN_ON]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.singleSignOn.description'
  },
  [FEATURES.ONE_TO_ONE_TECHNICAL_SUPPORT]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.oneToOneTechnicalSupport.description'
  },
  [FEATURES.EMAIL_AND_IN_APP_CHAT]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.emailAndInAppChat.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.emailAndInAppChat.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.emailAndInAppChat.description'
  },
  [FEATURES.PHONE_SUPPORT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.phoneSupport.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.phoneSupport.description'
  },
  [FEATURES.LISTS]: {
    'sales-hub-free': 'upgrades.featureTableMC0672.features.lists.description',
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.lists.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.lists.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.lists.description'
  },
  [FEATURES.ADVANCED_LIST_CRITERIA]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.advancedListCriteria.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.advancedListCriteria.description'
  },
  [FEATURES.MULTIPLE_CURRENCIES]: {
    'sales-hub-starter': 'upgrades.featureTableMC0672.features.multipleCurrencies.description',
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.multipleCurrencies.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.multipleCurrencies.description'
  },
  [FEATURES.DUPLICATE_MANAGEMENT]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.duplicateManagement.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.duplicateManagement.description'
  },
  [FEATURES.LINKEDIN_CRM_SYNC_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.linkedinCrmSyncIntegration.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.linkedinCrmSyncIntegration.description'
  },
  [FEATURES.SALES_EMAIL_FREQUENCY_CONTROLS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesEmailFrequencyControls.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesEmailFrequencyControls.description'
  },
  [FEATURES.SALESFORCE_INTEGRATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.salesforceIntegration.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesforceIntegration.description'
  },
  [FEATURES.SALESFORCE_CUSTOM_OBJECT_SYNC]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.salesforceCustomObjectSync.description'
  },
  [FEATURES.WORKFLOWS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.workflows.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflows.description'
  },
  [FEATURES.WORKFLOW_EXTENSIONS]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.workflowExtensions.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflowExtensions.description'
  },
  [FEATURES.AUTOMATIC_LEAD_ROTATION]: {
    'sales-hub-professional': 'upgrades.featureTableMC0672.features.automaticLeadRotation.description',
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.automaticLeadRotation.description'
  },
  [FEATURES.TRIGGER_SEQUENCES]: {},
  [FEATURES.WORKFLOW_HEALTH_MONITORING]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.workflowHealthMonitoring.description'
  },
  [FEATURES.CUSTOM_EVENTS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customEvents.description'
  },
  [FEATURES.CUSTOM_OBJECTS]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.customObjects.description'
  },
  [FEATURES.SENSITIVE_DATA]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.sensitiveData.description'
  },
  [FEATURES.STANDARD_SANDBOX_ACCOUNT]: {
    'sales-hub-enterprise': 'upgrades.featureTableMC0672.features.standardSandboxAccount.description'
  }
};